// import Cookies from 'js-cookie';
// import { useCallback, useEffect, useState } from 'react';
// export const useDrafts = (draftName) => {
//   const [drafts, setDrafts] = useState([]);

//   useEffect(() => {
//     const orders = Cookies.get(draftName);
//     if (orders) {
//       try {
//         const ListOrders = JSON.parse(orders);
//         if (ListOrders && Array.isArray(ListOrders) && ListOrders.length > 0) {
//           setDrafts(ListOrders);
//         }
//       } catch (error) {
//         console.error("Failed to parse JSON:", error);
//       }
//     }
//   }, []);


//   const handleUpdateDraft = useCallback(async (propertyName, newDraft) => {

//     if (!newDraft.ProductsId) {
//       console.error('Update failed: Draft missing ProductsId:', newDraft);
//       return;
//     }

//     const orders = Cookies.get(draftName);
//     let updatedDrafts = [];

//     if (orders) {
//       const ListOrders = JSON.parse(orders);
//       if (ListOrders && Array.isArray(ListOrders)) {
//         const existingDraft = ListOrders.find(pro => pro.ProductsId == newDraft.ProductsId);

//         if (existingDraft) {
//           const updatedDraft = {
//             ...existingDraft,
//             //requestedqty: parseFloat(existingDraft.requestedqty) + parseFloat(newDraft.requestedqty),
//             [propertyName]: parseFloat(existingDraft[propertyName] || 0) + parseFloat(newDraft[propertyName] || 0),
//           };
//           updatedDrafts = ListOrders.filter(pro => pro.ProductsId !== newDraft.ProductsId).concat(updatedDraft);
//         } else {
//           //updatedDrafts = [...ListOrders, newDraft];
//           Cookies.remove(draftName); // first remove old one 
//           Cookies.set(draftName, JSON.stringify([...ListOrders, newDraft])); // update to the new one
//           console.log("❌", [...ListOrders, newDraft]);
//         }
//       }
//     } else {
//       console.log("First Time if orders is are not exist in the cookies");

//       Cookies.set(draftName, JSON.stringify([newDraft]));
//     }

//     // Cookies.set(draftName, JSON.stringify(updatedDrafts));
//     setDrafts(updatedDrafts);
//   }, []);





//   const handleRemoveDraft = useCallback(async (productId) => {
//     const orders = Cookies.get(draftName);
//     if (orders) {
//       const ListOrders = JSON.parse(orders);
//       if (ListOrders && Array.isArray(ListOrders)) {
//         const newOrderList = ListOrders.filter(pro => pro.ProductsId !== productId);
//         Cookies.set(draftName, JSON.stringify(newOrderList));
//         setDrafts(newOrderList);
//       }
//     }
//   }, []);


//   return {
//     drafts,
//     handleUpdateDraft,
//     handleRemoveDraft,
//   };
// };



// import Cookies from 'js-cookie';
// import { useCallback, useEffect, useState } from 'react';

// export const useDrafts = (draftName) => {
//   const [drafts, setDrafts] = useState([]);

//   useEffect(() => {
//     const orders = Cookies.get(draftName);
//     if (orders) {
//       try {
//         const ListOrders = JSON.parse(orders);
//         if (Array.isArray(ListOrders)) {
//           setDrafts(ListOrders);
//         }
//       } catch (error) {
//         console.error("Failed to parse JSON:", error);
//       }
//     }
//   }, [draftName]);

//   const handleUpdateDraft = useCallback(async (propertyName, newDraft) => {
//     if (!newDraft.ProductsId) {
//       console.error('Update failed: Draft missing ProductsId:', newDraft);
//       return;
//     }

//     const orders = Cookies.get(draftName);
//     let updatedDrafts = [];

//     if (orders) {
//       const ListOrders = JSON.parse(orders);
//       if (Array.isArray(ListOrders)) {
//         const existingDraft = ListOrders.find(pro => pro.ProductsId === newDraft.ProductsId);

//         if (existingDraft) {
//           const updatedDraft = {
//             ...existingDraft,
//             [propertyName]: parseFloat(existingDraft[propertyName] || 0) + parseFloat(newDraft[propertyName] || 0),
//           };
//           updatedDrafts = ListOrders.map(pro => 
//             pro.ProductsId === newDraft.ProductsId ? updatedDraft : pro
//           );
//         } else {
//           updatedDrafts = [...ListOrders, newDraft];
//         }
//       }
//     } else {
//       updatedDrafts = [newDraft];
//     }

//     Cookies.set(draftName, JSON.stringify(updatedDrafts));
//     setDrafts(updatedDrafts);
//   }, [draftName]);

//   const handleRemoveDraft = useCallback(async (productId) => {
//     const orders = Cookies.get(draftName);
//     if (orders) {
//       const ListOrders = JSON.parse(orders);
//       if (Array.isArray(ListOrders)) {
//         const newOrderList = ListOrders.filter(pro => pro.ProductsId !== productId);
//         Cookies.set(draftName, JSON.stringify(newOrderList));
//         setDrafts(newOrderList);
//       }
//     }
//   }, [draftName]);

//   return {
//     drafts,
//     handleUpdateDraft,
//     handleRemoveDraft,
//   };
// };



import { useCallback, useEffect, useState } from 'react';

export const useDrafts = (draftName) => {
  const [drafts, setDrafts] = useState([]);

  useEffect(() => {
    const orders = localStorage.getItem(draftName);
    if (orders) {
      try {
        const ListOrders = JSON.parse(orders);
        if (Array.isArray(ListOrders)) {
          setDrafts(ListOrders);
        }
      } catch (error) {
        console.error("Failed to parse JSON:", error);
      }
    }
  }, [draftName]);

  const handleUpdateDraft = useCallback(async (propertyName, newDraft) => {
    if (!newDraft.ProductsId) {
      console.error('Update failed: Draft missing ProductsId:', newDraft);
      return;
    }

    const orders = localStorage.getItem(draftName);
    let updatedDrafts = [];

    if (orders) {
      const ListOrders = JSON.parse(orders);
      if (Array.isArray(ListOrders)) {
        const existingDraft = ListOrders.find(pro => pro.ProductsId === newDraft.ProductsId);

        if (existingDraft) {
          const updatedDraft = {
            ...existingDraft,
            [propertyName]: parseFloat(existingDraft[propertyName] || 0) + parseFloat(newDraft[propertyName] || 0),
          };
          updatedDrafts = ListOrders.map(pro => 
            pro.ProductsId === newDraft.ProductsId ? updatedDraft : pro
          );
        } else {
          updatedDrafts = [...ListOrders, newDraft];
        }
      }
    } else {
      updatedDrafts = [newDraft];
    }

    localStorage.setItem(draftName, JSON.stringify(updatedDrafts));
    setDrafts(updatedDrafts);
  }, [draftName]);

  const handleRemoveDraft = useCallback(async (productId) => {
    const orders = localStorage.getItem(draftName);
    if (orders) {
      const ListOrders = JSON.parse(orders);
      if (Array.isArray(ListOrders)) {
        const newOrderList = ListOrders.filter(pro => pro.ProductsId !== productId);
        localStorage.setItem(draftName, JSON.stringify(newOrderList));
        setDrafts(newOrderList);
      }
    }
  }, [draftName]);

  return {
    drafts,
    handleUpdateDraft,
    handleRemoveDraft,
  };
};

